// ============================================================================
// vpn/VpnSettingsTab.tsx — политика протоколов базы: show все (store) + чекбокс
// расширенных (extended). SSoT — сервер (metadata_settings vpn.extended_enabled).
// ============================================================================

import { Button } from '@/components/ui/button';

export interface VpnProtocolInfo {
  code: string;
  label: string;
  kind: string; // store | extended
}

interface VpnSettingsTabProps {
  protocols: VpnProtocolInfo[];
  extendedEnabled: boolean;
  setExtendedEnabled: (v: boolean) => void;
  busy: boolean;
  onSave: () => void;
}

export function VpnSettingsTab({ protocols, extendedEnabled, setExtendedEnabled, busy, onSave }: VpnSettingsTabProps) {
  return (
    <div className="flex-1 min-h-0 overflow-auto p-3">
      <div className="max-w-2xl space-y-4">
        <div className="text-sm font-medium">Набор протоколов (политика базы)</div>
        <p className="text-xs text-muted-foreground">
          Базовые протоколы (WireGuard, OpenVPN, IKEv2, SSH) доступны всегда. Расширенные
          (L2TP, VLESS/Reality, VMess, Trojan, Shadowsocks, Hysteria2, TUIC) включаются
          явным действием и по умолчанию выключены.
        </p>
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={extendedEnabled} disabled={busy}
            onChange={(e) => setExtendedEnabled(e.target.checked)} />
          Разрешить расширенные протоколы
        </label>
        <Button size="sm" onClick={onSave} disabled={busy || protocols.length === 0}>
          Сохранить политику
        </Button>
        <div className="border-t pt-3">
          <div className="text-xs font-medium mb-2">Протоколы</div>
          <ul className="space-y-1">
            {protocols.map((p) => (
              <li key={p.code} className="flex items-center gap-2 text-xs">
                <span className="w-40">{p.label}</span>
                <span className={p.kind === 'store' ? 'text-muted-foreground' : 'text-amber-600'}>
                  {p.kind === 'store' ? 'базовый' : 'расширенный'}
                </span>
                {p.kind === 'extended' && !extendedEnabled && (
                  <span className="text-[11px] text-muted-foreground">— выключен</span>
                )}
              </li>
            ))}
            {protocols.length === 0 && <li className="text-xs text-muted-foreground">Загрузка…</li>}
          </ul>
        </div>
      </div>
    </div>
  );
}
